import { HYDRATE } from "next-redux-wrapper";
import { ActionsBrandList } from "./actions";

const initialState = { data: [], status: "fetch_init", message: "" };

function storeBrandList(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeBrandList };
	case ActionsBrandList.LOAD_GET_BRAND_LIST:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsBrandList.RES_GET_BRAND_LIST:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsBrandList.ERR_GET_BRAND_LIST:
		return {
			...state,
			status: "fetch_error",
			message: "Error...",
		};
	default:
		return { ...state };

	}

}

export default storeBrandList;
